module.exports = __webpack_public_path__ + "static/media/blogs.9849ef4a.svg";